import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

import {
  updateColumnMapping,
  getDataVisualization,
} from "../../network/cipAPI";

import DupontButton from "../../components/DupontButton";
import DupontRadio from "../../components/DupontRadio";
import InputBox from "../../components/InputBox";
import Dropdown from "../../components/Dropdown";
import DupontDialog from "../../components/DupontDialog";
import DupontCheckbox from "../../components/DupontCheckbox";
import AgTable from "../../components/AgTable";
import createNotification, {
  SUCCESS_NOTIFICATION,
  ERROR_NOTIFICATION,
} from "../../components/Notifications";
import { OverlayLoader } from "../../components/PageLoading";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";

import { UpdateSetWithKey } from "../../utils/Utils";
import {
  COLUMN_OPTIONS,
  NORMALIZATION_COLUMN_OPTIONS,
  TRAIN_OPTIONS,
  SEGMENT_OPTIONS,
  REFERENCE_CONDITION_OPTIONS,
  extractAllColumnMappingKeys,
} from "./columns.config";
import { DATA_VISUALISATION_COL_DEF } from "./dataVisualisationTable.config";

import { ValueStrings } from "../../utils/constantsString";

import "./index.scss";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";

const ColumnSelection = ({
  columnsOption,
  setColumnsOptions,
  segmentsOptions,
  setSegmentsOptions,
  fileId,
  mappedColumn,
  mappedReference,
  isEdit = false,
  setDatasetDetails,
  plantName,
  water_type,
  selectedRadioColumn,
  setSelectedRadioColumn,
  setMappedReference,
  setIsProceedEnabled,
  setIsNormalizationColumnFilled,
  config,
  selectedCheckColumn,
  setSelectedCheckColumn,
  setView,
  referenceConditions,
}) => {
  const { t, i18n } = useTranslation();
  const prevLanguage = React.useRef(i18n.language);
  const columns = COLUMN_OPTIONS(t);
  const normalizedColumns = NORMALIZATION_COLUMN_OPTIONS(t);
  const segmentoptions = SEGMENT_OPTIONS(t);
  const [selectedColumns, setselectedColumns] = useState({
    sel_train: 1,
    sel_rack: 1,
  });
  const trainsOptions = TRAIN_OPTIONS(
    t,
    config,
    selectedColumns && selectedColumns["sel_train"] > 0
      ? selectedColumns["sel_train"] - 1
      : ""
  );
  const refConditionOptions = REFERENCE_CONDITION_OPTIONS(
    t,
    selectedRadioColumn,
    selectedCheckColumn
  );

  const { flow, pressure, feed_suspended, filtrate_suspended, temperature } =
    useSelector((state) => state);
  const [defaultSettingUnit, setDefaultSettingUnit] = useState({
    flow,
    pressure,
    feed_suspended,
    filtrate_suspended,
    temperature,
  });
  const dataVisualisationColumn = DATA_VISUALISATION_COL_DEF(
    t,
    defaultSettingUnit
  );

  const [trainscolumns, setTrainscolumns] = useState([]);
  const [showDataVisualizationPopup, setshowDataVisualizationPopup] =
    useState(false);
  const [dataVisualisationRow, setDataVisualisationRow] = useState([]);
  const [isColEnabled, setisColEnabled] = useState(false);
  const [dataVisualisationEnabled, setDataVisualisationEnabled] =
    useState(true);
  const [changedSelectedColumns, setChangedSelectedColumns] = useState({});
  const [hasConfirmed, setHasConfirmed] = useState(false);
  // const [selectedRadioColumn, setSelectedRadioColumn] = useState({
  //   ["column5"]: "feed_flowrate",
  //   ["column8"]: "pressure_drop",
  // });
  // const [selectedCheckColumn, setSelectedCheckColumn] = useState({
  //   ["column88"]: ["filtrate_flowrate"],
  // });
  const [dropdownColumns, setDropdownColumns] = useState(columnsOption);
  const [showOverLayLoader, setShowOverLayLoader] = useState(false);
  const [viewNoteMessage, setViewNoteMessage] = useState(false);
  const userName = useSelector((state) => state.userName);

  const validateRequiredReferenceFields = () => {
    const requiredFields = Object.values(refConditionOptions)
      .filter((option) => option.isMandatory && !option.hide)
      .map((option) => option.key);

    return requiredFields.every((field) => {
      const referenceValue = referenceConditions && referenceConditions[field];
      return (
        referenceValue !== undefined &&
        referenceValue !== null &&
        referenceValue !== ""
      );
    });
  };

  // check if all mandatory fields are filled (use the same logic as getConfirmButtonState)
  const areMandatoryFieldsFilled = () => {
    const {
      date,
      feed_temp,
      sel_segment,
      feed_pressure,
      filtrate_pressure,
      tmp_drop,
      feed_flowrate,
      filtrate_flowrate,
    } = selectedColumns;
    return (
      date &&
      feed_temp &&
      sel_segment &&
      (tmp_drop || (feed_pressure && filtrate_pressure)) &&
      (feed_flowrate || filtrate_flowrate)
    );
  };

  // Watch for changes in selectedColumns and setIsProceedEnabled(true) if any mandatory is missing (so button is disabled)
  useEffect(() => {
    if (!areMandatoryFieldsFilled()) {
      setIsProceedEnabled && setIsProceedEnabled(true); // true disables the button in AnalyseData
    }
  }, [selectedColumns, t]);

  useEffect(() => {
    if (isEdit) {
      setChangedSelectedColumns({});
    }
  }, [isEdit]);

  useEffect(() => {
    setselectedColumns({
      ...mappedColumn,
      ["sel_modules_per_rack"]: "",
      ["sel_module_used"]: "",
      ["sel_active_area"]: "",
    });
    if (
      mappedColumn &&
      mappedColumn.hasOwnProperty("norm_permeate_flow") &&
      mappedColumn.hasOwnProperty("norm_pressure_drop")
    ) {
      setIsNormalizationColumnFilled(true);
    }
    if (!Array.isArray(mappedColumn)) {
      // const col5 = mappedColumn.concentrate_flowrate
      //   ? "concentrate_flowrate"
      //   : "feed_flowrate";

      const col8 =
        mappedColumn.filtrate_pressure && mappedColumn.feed_pressure
          ? "feed_pressue&filtrate_pressure"
          : "tmp_drop";

      setSelectedRadioColumn({
        ...selectedRadioColumn,
        ["column8"]: col8,
      });

      const selectedFlows = [];

      if (mappedColumn.feed_flowrate) {
        selectedFlows.push("feed_flowrate");
      }

      if (mappedColumn.filtrate_flowrate) {
        selectedFlows.push("filtrate_flowrate");
      }

      if (selectedFlows.length > 0) {
        setSelectedCheckColumn({
          ...selectedCheckColumn,
          ["column88"]: selectedFlows,
        });
      } else {
        setSelectedCheckColumn({
          ...selectedCheckColumn,
          ["column88"]: ["filtrate_flowrate"],
        });
      }
    }

    if (isEdit && mappedReference) {
      setDataVisualisationEnabled(false);
      setisColEnabled(true);
      // Clear any changed columns when opening in edit mode
      setChangedSelectedColumns({});
    }
  }, [mappedColumn]);

  useEffect(() => {
    if (typeof config === "object" && !Array.isArray(config)) {
      const { sel_train, sel_rack } = selectedColumns;
      if (config?.trains.length >= 1) {
        setTrainscolumns(
          TRAIN_OPTIONS(t, config, sel_train > 0 ? sel_train - 1 : "")
        );
      }
      if (
        typeof selectedColumns === "object" &&
        !Array.isArray(selectedColumns)
      ) {
        let num_modules_per_rack = "";
        let tol_active_area = "";
        let modules_used = "";
        let installation_year = "";
        if (sel_train && sel_rack) {
          const train = config.trains.find(
            (op) => op.train_id === parseInt(selectedColumns.sel_train)
          );
          // const pass = train?.passes.find(
          //   (pass) => pass.pass_id === parseInt(selectedColumns.sel_pass)
          // );
          if (sel_rack === "All") {
            let totalModules = 0;
            let totalNoActiveArea = 0;
            train.racks.forEach((element) => {
              totalModules += +element.num_modules_per_rack;
              const NumOfModulesPerRack = +element.num_modules_per_rack;
              const NumOfActiveAreaPerRack = +element.active_area;

              const currentNoActiveArea =
                NumOfModulesPerRack * NumOfActiveAreaPerRack;
              const cumulativeNoActiveArea =
                currentNoActiveArea + totalNoActiveArea;

              totalNoActiveArea = cumulativeNoActiveArea;
            });
            num_modules_per_rack = totalModules;
            tol_active_area = totalNoActiveArea;
            modules_used = "";
            installation_year = "";
          } else {
            const rack = train?.racks.find(
              (rack) => rack.rack_id === parseInt(selectedColumns.sel_rack)
            );
            num_modules_per_rack = rack?.num_modules_per_rack || "";
            tol_active_area =
              rack?.num_modules_per_rack * rack?.active_area || "";
            modules_used = rack?.modules_used || "";
            installation_year = rack?.installation_year || "";
          }
        } else {
          num_modules_per_rack = "";
          tol_active_area = "";
          modules_used = "";
          installation_year = "";
        }

        setselectedColumns({
          ...selectedColumns,
          ["sel_modules_per_rack"]: num_modules_per_rack,
          ["sel_active_area"]: tol_active_area,
          ["sel_module_used"]: modules_used,
          ["installation_year"]: installation_year,
        });

        if (!isEdit || Object.keys(changedSelectedColumns).length > 0) {
          setChangedSelectedColumns((prevSet) =>
            UpdateSetWithKey(
              prevSet,
              ["sel_modules_per_rack"],
              num_modules_per_rack
            )
          );
          setChangedSelectedColumns((prevSet) =>
            UpdateSetWithKey(prevSet, ["sel_active_area"], tol_active_area)
          );
          setChangedSelectedColumns((prevSet) =>
            UpdateSetWithKey(prevSet, ["sel_module_used"], modules_used)
          );
        }
      }
    }
  }, [selectedColumns, config, t]);

  useEffect(() => {
    if (!fileId) {
      setselectedColumns([]);
      setDataVisualisationEnabled(true);
      setDropdownColumns([]);
      setColumnsOptions([]);
      setSegmentsOptions([]);
    }
  }, [fileId]);

  useEffect(() => {
    if (prevLanguage.current !== i18n.language && prevLanguage.current) {
      prevLanguage.current = i18n.language;
    }
  }, [i18n.language]);

  useEffect(() => {
    var filteredOptions = Object.values(columnsOption).filter((obj) => {
      return Object.values(selectedColumns).indexOf(obj) == -1;
    });
    setDropdownColumns(filteredOptions);
  }, [
    selectedColumns,
    columnsOption,
    selectedRadioColumn,
    selectedCheckColumn,
  ]);

  const onDropdownValChange = (value, key, event) => {
    setDataVisualisationEnabled(true);
    setisColEnabled(false);

    if (event && event.stopPropagation) {
      event.stopPropagation();
    }

    setselectedColumns((prev) => ({ ...prev, [key]: value }));
    setChangedSelectedColumns((prevSet) =>
      UpdateSetWithKey(prevSet, key, value)
    );
    setHasConfirmed(false); // Any change after confirm re-enables the button
  };

  const onTrainsValChange = (value, key) => {
    if (key === "sel_train") {
      value = value ? value.toString() : "";

      setselectedColumns({
        ...selectedColumns,
        [key]: value,
        sel_rack: "",
      });
      setChangedSelectedColumns((prevSet) =>
        UpdateSetWithKey(prevSet, key, value)
      );
      setChangedSelectedColumns((prevSet) =>
        UpdateSetWithKey(prevSet, ["sel_rack"], "")
      );
    } else {
      setselectedColumns({
        ...selectedColumns,
        [key]: value,
      });
      setChangedSelectedColumns((prevSet) =>
        UpdateSetWithKey(prevSet, key, value)
      );
    }
  };

  const getKey = (column) => {
    const key =
      column.options === undefined
        ? column.key
        : selectedRadioColumn[column.key];
    return key;
  };

  const handleOptionChange = (event) => {
    setisColEnabled(false);
    setDataVisualisationEnabled(true);
    const { name, value } = event.target;
    const prevKey = selectedRadioColumn[name];

    let updatedSelectedColumns = { ...selectedColumns };

    if (prevKey && updatedSelectedColumns[prevKey]) {
      delete updatedSelectedColumns[prevKey];
    }

    let clearedFields = {};

    if (value === "tmp_drop") {
      clearedFields = {
        feed_pressure: "",
        filtrate_pressure: "",
      };

      delete updatedSelectedColumns.feed_pressure;
      delete updatedSelectedColumns.filtrate_pressure;
    } else if (value === "feed_pressue&filtrate_pressure") {
      clearedFields = {
        tmp_drop: "",
      };

      delete updatedSelectedColumns.tmp_drop;
    }

    setselectedColumns({
      ...updatedSelectedColumns,
      ...clearedFields,
    });

    setSelectedRadioColumn({ ...selectedRadioColumn, [name]: value });
    setHasConfirmed(false);

    Object.keys(clearedFields).forEach((key) => {
      setChangedSelectedColumns((prevSet) =>
        UpdateSetWithKey(prevSet, key, clearedFields[key])
      );
    });
  };

  const getchecked = (column, key) => {
    return selectedRadioColumn[column] === key;
  };

  const getcheckchecked = (column, key) => {
    return selectedCheckColumn[column]?.includes(key);
  };

  const handlecheckOptionChange = useCallback(
    (column, key, event) => {
      if (
        event?.target?.closest(".clear-button") ||
        event?.target?.closest(".dropdown-component")
      ) {
        return;
      }

      setisColEnabled(false);
      setDataVisualisationEnabled(true);

      const isKeySelected = selectedCheckColumn[column]?.includes(key);

      const updatedCheckColumn = {
        ...selectedCheckColumn,
        [column]: isKeySelected
          ? selectedCheckColumn[column].filter((item) => item !== key)
          : [...(selectedCheckColumn[column] || []), key],
      };

      setSelectedCheckColumn(updatedCheckColumn);

      if (isKeySelected) {
        setselectedColumns((prev) => {
          const newState = { ...prev };
          delete newState[key];
          return newState;
        });

        setChangedSelectedColumns((prev) => {
          const newSet = { ...prev };
          delete newSet[key];
          return newSet;
        });
      }
    },
    [selectedCheckColumn]
  );

  const openDataVisualizationPopup = async () => {
    setShowOverLayLoader(true);
    try {
      const response = await getDataVisualization(fileId);
      const recordCount = response.data.length;
      if (recordCount === 1000) {
        setViewNoteMessage(true);
      }
      if (response && response.data) {
        setDataVisualisationRow(response.data);
      }
    } catch (err) {
      console.log("openDataVisualizationPopup", err);
    } finally {
      setShowOverLayLoader(false);
      return setshowDataVisualizationPopup(true);
    }
  };

  const onCloseClicked = async (value) => {
    setshowDataVisualizationPopup(false);
  };

  // Handler for row click in data visualization table
  const handleReferenceRowClick = (event) => {
    // Format all number values and numeric strings to 2 decimal places
    const formattedData = { ...event?.data };
    Object.keys(formattedData).forEach((key) => {
      const val = formattedData[key];
      if (
        (typeof val === "number" && !isNaN(val)) ||
        (typeof val === "string" && val !== "" && !isNaN(Number(val)))
      ) {
        formattedData[key] = parseFloat(val).toFixed(2);
      }
    });
    // Set firstLoad.current = false in referenceCondition if available
    if (
      typeof window !== "undefined" &&
      window.firstLoadRefForReferenceCondition
    ) {
      window.firstLoadRefForReferenceCondition.current = false;
    }
    setMappedReference(formattedData);
    setView(2);
    createNotification(
      SUCCESS_NOTIFICATION,
      t("analyseData.referenceEdited"),
      ""
    );
  };

  const getConfirmButtonState = () => {
    const {
      date,
      feed_temp,
      sel_segment,
      feed_pressure,
      filtrate_pressure,
      tmp_drop,
      feed_flowrate,
      filtrate_flowrate,
    } = selectedColumns;

    const hasAllInputs =
      date &&
      feed_temp &&
      sel_segment &&
      (tmp_drop || (feed_pressure && filtrate_pressure)) &&
      (feed_flowrate || filtrate_flowrate);

    // In edit mode, enable only if changes are made
    if (isEdit) {
      if (!hasAllInputs || Object.keys(changedSelectedColumns).length === 0) {
        return true;
      }
      return false;
    }

    // In create mode, enable only if changes are made and not confirmed
    if (!isEdit) {
      if (
        !hasAllInputs ||
        hasConfirmed === true ||
        Object.keys(changedSelectedColumns).length === 0
      ) {
        return true;
      }
      return false;
    }
    return true;
  };

  const getFormattedDate = (dateString) => {
    const date = moment(dateString).isValid();
    return date ? moment(dateString).format(ValueStrings.dateFormat) : "";
  };

  const onConfirmColumn = async () => {
    setShowOverLayLoader(true);
    try {
      // Get all possible mapping keys from columns config, normalized, train, and segment options
      const allKeys = extractAllColumnMappingKeys(
        columns,
        normalizedColumns,
        trainsOptions,
        segmentoptions
      );

      // Build payload with all fields and their latest values
      let payload = {};
      allKeys.forEach((key) => {
        payload[key] =
          changedSelectedColumns[key] !== undefined
            ? changedSelectedColumns[key]
            : selectedColumns[key] !== undefined
            ? selectedColumns[key]
            : "";
      });

      const currentRadioSelection = selectedRadioColumn["column8"];

      if (currentRadioSelection === "tmp_drop") {
        payload.feed_pressure = "";
        payload.filtrate_pressure = "";

        if (!payload.tmp_drop) {
          payload.tmp_drop = selectedColumns.tmp_drop || "";
        }
      } else if (currentRadioSelection === "feed_pressue&filtrate_pressure") {
        payload.tmp_drop = "";

        if (!payload.feed_pressure) {
          payload.feed_pressure = selectedColumns.feed_pressure || "";
        }
        if (!payload.filtrate_pressure) {
          payload.filtrate_pressure = selectedColumns.filtrate_pressure || "";
        }
      }

      const selectedFlows = selectedCheckColumn["column88"] || [];

      payload.feed_flowrate = "";
      payload.filtrate_flowrate = "";
      payload.concentrate_flowrate = "";

      selectedFlows.forEach((flowKey) => {
        if (selectedColumns[flowKey]) {
          payload[flowKey] = selectedColumns[flowKey];
        }
      });

      // Handle segment selection
      if (!payload.sel_segment) {
        if (Array.isArray(segmentsOptions) && segmentsOptions.length === 1) {
          payload.sel_segment = segmentsOptions[0];
        }
      }

      Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null) {
          payload[key] = "";
        }
      });

      const response = await updateColumnMapping(fileId, payload);

      if (response) {
        setView(2);
        setMappedReference(response.ref);
        setDataVisualisationEnabled(false);
        setChangedSelectedColumns({});
        setHasConfirmed(true);

        if (response?.detail?.error) {
          createNotification(ERROR_NOTIFICATION, response?.detail?.error, "");
        } else {
          createNotification(
            SUCCESS_NOTIFICATION,
            t("analyseData.columnMapped"),
            ""
          );
        }

        setDataVisualisationEnabled(false);
        setisColEnabled(true);

        if (
          payload.hasOwnProperty("norm_permeate_flow") &&
          payload.hasOwnProperty("norm_pressure_drop")
        ) {
          setIsNormalizationColumnFilled(true);
        }

        const referenceFieldsValid = validateRequiredReferenceFields();
        setIsProceedEnabled(referenceFieldsValid);
      } else {
        if (response?.detail) {
          createNotification(ERROR_NOTIFICATION, response.detail, "");
        } else {
          createNotification(
            ERROR_NOTIFICATION,
            "Failed to update column mapping",
            ""
          );
        }
      }
    } catch (err) {
      createNotification(
        ERROR_NOTIFICATION,
        err.response?.data?.detail || "An error occurred while mapping columns",
        ""
      );
    } finally {
      setShowOverLayLoader(false);
      setIsProceedEnabled && setIsProceedEnabled(!areMandatoryFieldsFilled());
    }
  };

  const getTrainValue = (value) => {
    if (value !== undefined && value !== null) {
      if (typeof value === "boolean" || typeof value === "number") {
        return value.toString();
      }
      return value;
    }
  };

  useEffect(() => {
    // If only one segment option, set sel_segment automatically if not set
    if (
      Array.isArray(segmentsOptions) &&
      segmentsOptions.length === 1 &&
      (!selectedColumns["sel_segment"] || selectedColumns["sel_segment"] === "")
    ) {
      setselectedColumns((prev) => ({
        ...prev,
        sel_segment: segmentsOptions[0],
      }));
    }
  }, [segmentsOptions]);

  return (
    <div className="lightGrayBorder padding10 position-relative">
      {showOverLayLoader && <OverlayLoader customHeight={"590px"} />}
      <div className="box-title-info  box-title text-align-left">
        {t("analyseData.selectColumn")}
        <PopoverText
          descriptor={<img src={InfoIconGreen} alt="icon" />}
          descriptionText={t("analyseData.selectColumnDescription")}
        />
      </div>
      <div className="flex-ai-center container-padding">
        <div className="grid-container-column">
          {Object.keys(columns).map((column, index) => (
            <div
              key={index}
              className={
                columns[column].options || columns[column].checkboxOptions
                  ? ""
                  : "grid-item-column"
              }
            >
              <div>
                {columns[column].options ? (
                  <>
                    <label className="marginBtm10">
                      {columns[column].name}
                    </label>
                    {columns[column].isMandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    {Object.values(columns[column].options).map((option) => (
                      <div
                        key={option.key}
                        onChange={handleOptionChange}
                        className="checkbox-container"
                      >
                        <div className="marginBtm10 grid-item-column">
                          <DupontRadio
                            text={option.name.replace(
                              "<unit>",
                              `(${defaultSettingUnit[option.unit]})`
                            )}
                            fontsize={"font-14"}
                            checked={getchecked(column, option.key)}
                            value={option.key}
                            name={column}
                            isRequired={
                              option.isMandatory ? option.isMandatory : false
                            }
                          />
                          {option.key === "feed_pressue&filtrate_pressure" &&
                            getchecked(column, option.key) && (
                              <div key={option.key}>
                                <div className="width-dropdown marginBtm10">
                                  <Dropdown
                                    value={selectedColumns[option.key1]}
                                    options={dropdownColumns}
                                    onChange={(value) =>
                                      onDropdownValChange(value, option.key1)
                                    }
                                    labelText={option.name1}
                                  />
                                </div>
                                <div className="width-dropdown">
                                  <Dropdown
                                    value={selectedColumns[option.key2]}
                                    options={dropdownColumns}
                                    onChange={(value) =>
                                      onDropdownValChange(value, option.key2)
                                    }
                                    labelText={option.name2}
                                  />
                                </div>
                              </div>
                            )}
                          {option.key === "tmp_drop" &&
                            getchecked(column, option.key) && (
                              <div key={option.key}>
                                <div className="width-dropdown">
                                  <Dropdown
                                    value={selectedColumns[option.key]}
                                    options={dropdownColumns}
                                    onChange={(value) =>
                                      onDropdownValChange(value, option.key)
                                    }
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : columns[column].checkboxOptions ? (
                  <>
                    <label className="marginBtm10">
                      {columns[column].name}
                    </label>
                    {columns[column].isMandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    {Object.values(columns[column].checkboxOptions).map(
                      (option) => (
                        <div
                          key={option.key}
                          onChange={(e) =>
                            handlecheckOptionChange(column, option.key, e)
                          }
                          className="checkbox-container"
                        >
                          <div className="marginBtm5 grid-item-column">
                            <DupontCheckbox
                              labelText={option.name.replace(
                                "<unit>",
                                `(${defaultSettingUnit[option.unit]})`
                              )}
                              checked={getcheckchecked(column, option.key)}
                              value={option.key}
                              onClick={(e) => {
                                e.stopPropagation();

                                const isSelected = selectedCheckColumn[
                                  column
                                ]?.includes(option.key);

                                const updatedCheckColumn = {
                                  ...selectedCheckColumn,
                                  [column]: isSelected
                                    ? selectedCheckColumn[column].filter(
                                        (item) => item !== option.key
                                      )
                                    : [
                                        ...(selectedCheckColumn[column] || []),
                                        option.key,
                                      ],
                                };

                                setSelectedCheckColumn(updatedCheckColumn);

                                if (isSelected) {
                                  setselectedColumns((prev) => {
                                    const newState = { ...prev };
                                    delete newState[option.key];
                                    return newState;
                                  });

                                  setChangedSelectedColumns((prev) => {
                                    const newSet = { ...prev };
                                    delete newSet[option.key];
                                    return newSet;
                                  });
                                }
                              }}
                            />
                            <div
                              className="width-dropdown marginBtm5"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Dropdown
                                value={selectedColumns[option.key]}
                                options={dropdownColumns}
                                onChange={(value, event) => {
                                  onDropdownValChange(value, option.key, event);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </>
                ) : (
                  <>
                    <label className="text-left ">
                      {columns[column].name.replace(
                        "<unit>",
                        `(${defaultSettingUnit[columns[column].unit]})`
                      )}
                    </label>
                    {columns[column].isMandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </>
                )}
              </div>
              <div className="width-dropdown">
                {columns[column].dropdown && (
                  <Dropdown
                    value={selectedColumns[getKey(columns[column])]}
                    options={dropdownColumns}
                    onChange={(value) =>
                      onDropdownValChange(value, getKey(columns[column]))
                    }
                    isRequired
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <div className="grid-container-column">
          <div className="margin-top-10">
            <div className="absolute-element">
              <PopoverText
                descriptor={<img src={InfoIconGreen} alt="icon" />}
                descriptionText={
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t(
                        "analyseData.normalizedVariablesSelectionDescription"
                      ),
                    }}
                  />
                }
              />
            </div>
            {Object.keys(normalizedColumns).map((normalizedColumn, index) => (
              <div key={index} className="grid-item-column marginBtm10">
                <label className="text-left ">
                  {normalizedColumns[normalizedColumn].name.replace(
                    "<unit>",
                    `(${
                      defaultSettingUnit[
                        normalizedColumns[normalizedColumn].unit
                      ]
                    })`
                  )}
                </label>
                <div className="width-dropdown">
                  <Dropdown
                    value={
                      selectedColumns[
                        getKey(normalizedColumns[normalizedColumn])
                      ]
                    }
                    options={dropdownColumns}
                    onChange={(value) =>
                      onDropdownValChange(
                        value,
                        getKey(normalizedColumns[normalizedColumn])
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </div>
          <div
            className="grid-container-trains"
            style={{ position: "relative" }}
          >
            <div className="absolute-element-right">
              <PopoverText
                descriptor={<img src={InfoIconGreen} alt="icon" />}
                descriptionText={t(
                  "analyseData.selectNormalizedVariablesDescription"
                )}
              />
            </div>
            {Object.keys(trainscolumns).map((trainscolumn, index) => (
              <div key={index} className="flex-ai-center">
                <div>
                  {trainscolumns[trainscolumn].isSelect ? (
                    <Dropdown
                      labelText={trainscolumns[trainscolumn].name}
                      key={trainscolumns[trainscolumn].key}
                      options={trainscolumns[trainscolumn].options}
                      value={getTrainValue(
                        selectedColumns[trainscolumns[trainscolumn].key]
                      )}
                      onChange={(value) =>
                        onTrainsValChange(
                          value,
                          trainscolumns[trainscolumn].key
                        )
                      }
                    />
                  ) : (
                    <InputBox
                      labelText={trainscolumns[trainscolumn].name}
                      key={trainscolumns[trainscolumn].key}
                      value={
                        selectedColumns[trainscolumns[trainscolumn].key] || ""
                      }
                      disabled
                      hideClearBtn
                    />
                  )}
                </div>
              </div>
            ))}
            {Object.keys(segmentoptions).map((segmentoption, index) => (
              <div key={segmentoptions[segmentoption].key}>
                <label
                  className="marginBtm10"
                  style={{ whiteSpace: "nowrap", maxWidth: 205 }}
                >
                  {segmentoptions[segmentoption].name}
                  <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                </label>
                <Dropdown
                  key={`${segmentoptions[segmentoption].key}`}
                  options={segmentsOptions}
                  value={selectedColumns["sel_segment"] || ""}
                  onChange={(value) =>
                    onDropdownValChange(value, "sel_segment")
                  }
                />
              </div>
            ))}
          </div>
        </div>
        <div className="float-right margin-top-column-selection">
          <DupontButton
            customClass="margin-left-10 "
            disabled={getConfirmButtonState()}
            onClick={onConfirmColumn}
          >
            {t("analyseData.confirmColumnSelection")}
          </DupontButton>
          <DupontButton
            type="tertiary"
            onClick={openDataVisualizationPopup}
            customClass="margin-left-10 "
            disabled={dataVisualisationEnabled}
          >
            {t("analyseData.dataVisualization")}
          </DupontButton>
          {showDataVisualizationPopup && (
            <DupontDialog
              open={showDataVisualizationPopup}
              title={t("analyseData.dataVisualization")}
              cancelBtnText={t("ValueStrings.close")}
              onClose={onCloseClicked}
              maxWidth="xl"
            >
              <div className="view-note marginBtm5">
                {viewNoteMessage ? t("analyseData.viewDataNote") : ""}
              </div>
              <div className="visualization-table">
                <AgTable
                  columnDefs={dataVisualisationColumn}
                  rowData={dataVisualisationRow}
                  hideExport
                  customHeight={355}
                  context={{ handleReferenceRowClick }}
                />
              </div>
            </DupontDialog>
          )}
        </div>
      </div>
    </div>
  );
};
export default ColumnSelection;
